import React, {useCallback, useRef} from 'react';
import {Group} from 'three';
import {useHitTest} from 'hooks';
import {useARStore} from 'stores';
import {placeModel} from 'utils';

interface IARCoreReticleProps {}

const ARCoreReticle = ({}: IARCoreReticleProps) => {
  const ref = useRef<Group>(null);
  const modelData = useARStore(s => s.modelData);
  const hasHitTest = useARStore(s => s.hasHitTest);

  useHitTest(ref);

  const handleClick = useCallback(() => {
    if (hasHitTest) {
      placeModel();
    }
  }, [hasHitTest]);

  return (
    <group ref={ref} scale={0.1} visible={!!modelData} onPointerEnter={handleClick}>
      <mesh>
        <meshBasicMaterial color={hasHitTest ? 'green' : 'yellow'} />
        <ringGeometry />
      </mesh>
      <mesh scale={1.4}>
        <meshBasicMaterial transparent opacity={0} />
        <sphereGeometry />
      </mesh>
    </group>
  );
};

export default React.memo(ARCoreReticle);
